import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTrending$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTrending extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '82af7d134db00a5822cf127aaa5ed967afe855de', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eec778e3c48347a7e4883cd4147cc37795b28100', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '11162ac6bf61bfcf1dc724684287334fba552ff2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.207 6H18.5a.5.5 0 0 1 .5.5v4.293a.5.5 0 0 1-.854.353L16.53 9.53l-4.676 4.677a.5.5 0 0 1-.707 0l-2.293-2.293a.5.5 0 0 0-.708 0l-4.262 4.263a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707l5.323-5.323a.5.5 0 0 1 .708 0l2.293 2.293a.5.5 0 0 0 .707 0L15.47 8.47l-1.617-1.616A.5.5 0 0 1 14.208 6", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-trending", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-trending"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-trending":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTrending$1);
            }
            break;
    } });
}

const CosmosIconTrending = CosmosIconTrending$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTrending, defineCustomElement };
